export enum APPLICATION_DETAILS_NAVIGATION {
  REVIEW = 'review',
  FORM = 'form',
  DOCUMENTS = 'documents',
}

export const applicationDetailsNavigation = [
  {
    path: APPLICATION_DETAILS_NAVIGATION.REVIEW,
    text: 'APPLICATION_DETAILS.REVIEW',
    additionalClass: 'd-flex',
  },
  {
    path: APPLICATION_DETAILS_NAVIGATION.FORM,
    text: 'APPLICATION_DETAILS.FORM',
    additionalClass: 'd-flex',
  },
  {
    path: APPLICATION_DETAILS_NAVIGATION.DOCUMENTS,
    text: 'APPLICATION_DETAILS.DOCUMENTS',
    additionalClass: 'd-flex',
  },
];